import { useQueryClient } from '@tanstack/react-query'
import i18n from 'i18next'
import React from 'react'
import { I18nextProvider as I18nextProviderBase } from 'react-i18next'
import { useMount } from 'react-use'

import { useUpdateMyProfileMutation } from '../hooks'
import { initI18n } from '../utils'

type I18nextLoadedContentProps = React.PropsWithChildren<{
  language: string
}>

export const I18nextLoadedContent = ({
  children,
  language,
}: I18nextLoadedContentProps) => {
  const queryClient = useQueryClient()
  const updateMyProfileMutation = useUpdateMyProfileMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['CurrentUserLanguage'] })
    },
  })

  useMount(() => {
    initI18n({
      language,
      onLanguageChange: (languageCode) => {
        updateMyProfileMutation.mutate({ languageCode })
      },
    })
  })

  return <I18nextProviderBase i18n={i18n}>{children}</I18nextProviderBase>
}
